export default "__VITE_ASSET__DWe8$Doc__"